import React from 'react';
import styled from 'styled-components';

const StyledPlayButton = styled.span`
    -o-transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("https://ctf-images.gammacdn.com/cdyxtpbavd4i/2JpSF2RDYhMNNgbxGzmhGI/809dc3749eeef6ba0f82147c2adae6b0/play.svg") no-repeat center center/17% auto;
    z-index:3;
    :hover{
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
      opacity:0.8;
    }
    `;

const PlayButton = () => {
  return <StyledPlayButton />;
};

export default PlayButton;
